import {ChangeDetectionStrategy, Component, inject, input, OnInit} from '@angular/core';
import {AttachFileParams} from "../../../../../../../core/types/file.types";
import {ProductPackagesFilesStateService} from "../../services/product-packages-files-state.service";
import {ProductPackagesModalService} from "../../services/product-packages-modal.service";
import {LoadingService} from "../../../../../../../core/services/loading.service";
import {
  AttachProductPackagesFileParams,
  DeleteFileParams,
  GetFilesParams,
  ProductPackageFile
} from "../../types/product-packages-modal.types";
import {productPackageFilesResourceType} from "../../configs/product-packages-modal-config";
import {FileCardComponent} from "../../../../../../../shared/components/ui/file-card/file-card.component";
import {
  FileUploadCardComponent
} from "../../../../../../../shared/components/ui/file-upload-card/file-upload-card.component";

@Component({
  selector: 'div[app-product-packages-files]',
  imports: [
    FileCardComponent,
    FileUploadCardComponent
  ],
  templateUrl: './product-packages-files.component.html',
  styleUrl: './product-packages-files.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductPackagesFilesComponent implements OnInit {
  productPackageId = input<number>(0);
  isEditModeActive = input<boolean>(false);

  private productPackagesFilesStateService: ProductPackagesFilesStateService = inject(ProductPackagesFilesStateService);
  private productPackagesModalService: ProductPackagesModalService = inject(ProductPackagesModalService);
  private loadingService: LoadingService = inject(LoadingService);

  public async ngOnInit(): Promise<void> {
    await this.getFiles();
  }

  public getFilesById(): Array<ProductPackageFile> {
    return this.productPackagesFilesStateService.getProductPackagesFilesById(this.productPackageId());
  }

  public async handleDelete(isImage: boolean, file: ProductPackageFile):  Promise<void> {
    const deleteFileParams: DeleteFileParams = {
      path: productPackageFilesResourceType.path,
      id: file.id
    };

    this.productPackagesModalService.deleteFile(deleteFileParams)
      .then(() => this.productPackagesFilesStateService.deleteFileById(file.id, this.productPackageId()));
  }

  public async attachFile({ parentId, fileId }: AttachFileParams): Promise<void> {
    const attachFileParams: AttachProductPackagesFileParams = {
      path: productPackageFilesResourceType.path,
      body: {
        fileId: fileId,
        productPackageId: parentId
      }
    };

    await this.productPackagesModalService.attachFile<ProductPackageFile>(attachFileParams)
      .then((data) => this.productPackagesFilesStateService.updateProductPackagesFilesState(this.productPackageId(), data));
  }

  private async getFiles(): Promise<void> {
    this.loadingService.setIsLoadingState(true);
    const params: GetFilesParams = {
      path: productPackageFilesResourceType.path,
      params: { productPackageId: this.productPackageId() }
    };

    await this.productPackagesModalService.getFiles(params)
      .then((data) => this.productPackagesFilesStateService.setProductPackagesFilesState(this.productPackageId(), data))
      .finally(() => this.loadingService.setIsLoadingState(false));
  }
}
